import { EventFragment } from "../../../../../../__generated__/graphql";
import EventsTooltip from "./components/EventsTooltip";

interface RemainingEventsProps {
  events: EventFragment[];
}

export default function RemainingEvents({ events }: RemainingEventsProps) {
  return (
    <EventsTooltip events={events}>
      <div className="text-xs text-secondary rounded-md cursor-pointer hover:text-white transition-all duration-300">
        {events.length} de plus...
      </div>
    </EventsTooltip>
  );
}
